import { createSlice } from "@reduxjs/toolkit";
import { getNavbarLinkList, saveNavbarLink, deleteNavbarLink } from "../controller/navbarLink.controller";
import { NavbarLink } from "../types/navbarLinkType";
import { SaveResponse } from "../types/common";

interface NavbarLinkState {
  loading: boolean;
  list: NavbarLink[];
  total: { pages: number; data: number };
  response: SaveResponse | null;
  error: string | null;
}

const initialState: NavbarLinkState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  response: null,
  error: null,
};

const navbarLinkSlice = createSlice({
  name: "navbarLink",
  initialState,
  reducers: {
    resetNavbarLinkResponse: (state) => {
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNavbarLinkList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getNavbarLinkList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getNavbarLinkList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data link navbar";
      })
      .addCase(saveNavbarLink.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveNavbarLink.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(saveNavbarLink.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan link navbar";
      })
      .addCase(deleteNavbarLink.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetNavbarLinkResponse } = navbarLinkSlice.actions;
export default navbarLinkSlice.reducer;
